import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";
export var ProductBasedCollectionPageWrapper = styled(Column).withConfig({
    componentId: "sc-5797a9e6-0"
})([
    "width:100%;max-width:1220px;margin:0 auto;padding:",
    ";",
    "{padding:0;}"
], getSpacing(0, "6x"), responsiveMediaQueries.mobile);
